import { v4 } from 'uuid';
import { httpClient } from '../../utils/http-client';
import encoderClient from '../../lib/encoder-client/EncoderClient';
import appEvents from '../events';
import Swal from 'sweetalert2';
import previewAreaLoadingStore from '../../pages/preview/loading-store';
import appConfig from '../../config';
import { logError } from '../../utils/logs';
import '../animation/resolution-fixer';
const extractRenderableAsset = (query, loopFn, options) => {
    const mapped = [...query].map(item => {
        const loop = loopFn ? loopFn(item) : true;
        const url = item.querySelector('source')?.getAttribute('src');
        return {
            url,
            loop,
            ...options
        };
    });
    return mapped.filter((item, index) => {
        if (item == null)
            return false;
        const foundItem = mapped.find(x => x.url == item.url);
        if (foundItem && index !== mapped.indexOf(foundItem))
            return false;
        return true;
    });
};
export default class RenderService {
    listeners;
    animationService;
    projectData;
    node;
    videos;
    audio;
    currentRequestId = '';
    qualityPreset = 'default';
    constructor() { }
    setup(animationService, projectData, qualityPreset) {
        this.animationService = animationService;
        this.projectData = projectData;
        this.node = animationService.getDom();
        this.qualityPreset = qualityPreset;
        this.prepareVideoData();
        this.prepareAudioData();
        return this;
    }
    attachEventListeners(listeners) {
        this.listeners = listeners;
        return this;
    }
    async renderAiCameraCrewVideo(sourceFile, retries = 0, delay = 0) {
        await new Promise(resolve => setTimeout(resolve, delay));
        try {
            const response = await httpClient.post('/render/tracked', {
                sourceFile,
                owner: appEvents.userId
            });
            return true;
        }
        catch (err) {
            if (retries < 3) {
                return this.renderAiCameraCrewVideo(sourceFile, retries + 1, delay > 0 ? delay * 2 : 2000);
            }
            return false;
        }
    }
    prepareVideoData() {
        this.videos = extractRenderableAsset(this.node.querySelectorAll('video'), item => {
            return !!!(item.parentElement?.hasAttribute('data-amelement') &&
                item.parentElement.getAttribute('data-amelement') == 'sermonclip');
        });
        console.log('Prepared Video Data:', this.videos);
        const clip = this.node.querySelector('[data-amelement="sermonclip"] > video > source');
        if (clip) {
            const url = clip.getAttribute('src');
            this.videos = this.videos.filter(item => item.url !== url);
            this.videos.push({
                url: clip.getAttribute('src'),
                startTime: 0,
                endTime: this.animationService.timeline.duration / 1000,
                volume: this.animationService.videoLevels
            });
        }
        console.log('Cleaned video data', this.videos);
    }
    prepareAudioData() {
        let audioLevel = this.animationService.audioLevels;
        console.log('Audio Level', audioLevel);
        this.audio = extractRenderableAsset(this.node.querySelectorAll('audio'), undefined, { volume: audioLevel });
    }
    getConnectionCode() {
        if (window.uData) {
            return window.uData['id'] + '-' + window.uData['user_nicename'] + '-' + window.siteNameShort;
        }
        return 'guest-' + v4();
    }
    getViewport() {
        const dimensionsObject = this.node.querySelector('#templateLoaded');
        let width = Number.parseInt(dimensionsObject?.getAttribute('fx'));
        let height = Number.parseInt(dimensionsObject?.getAttribute('fy'));
        // if(height > 1080) {
        //   // width = Math.ceil(determineWidth(width, height, 1080));
        //   height = Math.ceil(determineHeight(width,height, 720));
        //   // height = 1080;
        //   width =  720;
        //   console.log('width and height fixed', width, height);
        // }
        return {
            width,
            height
        };
    }
    output(preview) {
        console.log('Getting output');
        let requestId = v4();
        this.currentRequestId = requestId;
        const duration = this.animationService.timeline.duration / 1000;
        return {
            id: requestId,
            rawMp4: false,
            qualityPreset: this.qualityPreset,
            userIdentifier: appEvents.userId,
            projectId: this.projectData.id,
            videoData: {
                url: location.protocol + '//' + location.host + '/clipper-render?project_id=' + this.projectData.id,
                duration: this.animationService.timeline.duration / 1000,
                fps: 60,
                viewport: this.getViewport(),
                audioFiles: this.audio,
                videoFiles: this.videos,
                options: {
                    video: {
                        skipWait: true,
                        fadeOut: preview.videoFade
                    }
                }
            }
        };
    }
    checkIfEncoderIsReady() {
        if (!window.brushEncoder)
            throw 'Brush encoder client is not available.';
    }
    sendToEncoder(template, video, preview) {
        this.checkIfEncoderIsReady();
        this.connectToEncoder();
        this.executeQueue(template, video, preview);
    }
    executeQueue(template, video, preview) {
        console.log('Preview store', preview);
        if (appConfig.dontFireDownload)
            return console.log('Dont fire the download.');
        if (this.listeners.onBegin)
            this.listeners.onBegin();
        const listeners = this.listeners;
        setTimeout(() => {
            encoderClient
                .setupEventListeners(listeners)
                .queueVideo(this.output(preview))
                .then((resp) => {
                // const client = httpClient;
                // client.post('/user-stats/download-usage', {
                //   metadata: resp.data,
                //   template,
                //   video
                // });
            })
                .catch((err) => {
                console.error('Execute queue error', err);
                console.warn(err);
                if (err.message.includes('Video Duration')) {
                    logError('[VIDEO DURATION ERROR]', err);
                    Swal.fire({
                        title: 'Video Duration Error',
                        text: 'It appears there was an error while preprocessing your video and the duration has unexpectedly exceed our maximum limit. Please head back to step 3 and make the appropriate changes necessary to shorten your video length down to at most 2.5 minutes long.',
                        icon: 'warning',
                        confirmButtonText: 'Ok'
                    }).then(() => {
                        Swal.close();
                        previewAreaLoadingStore.set(false);
                    });
                }
                else {
                    logError('[ENCODER ERROR]', err);
                    Swal.fire({
                        title: 'Encoder Error',
                        text: 'There was an error while processing your video. Please try again later or contact support if the issue persists.',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    }).then(() => {
                        Swal.close();
                        previewAreaLoadingStore.set(false);
                    });
                }
            });
        }, 3000);
    }
    connectToEncoder() {
        encoderClient.setupEventListeners(this.listeners);
    }
    OLDconnectToEncoder() {
        brushEncoder
            .connect(this.getConnectionCode())
            .removeAllListeners()
            .on('start', (notification) => {
            if (this.listeners.onConnect)
                this.listeners.onConnect(notification);
        })
            .on('progress', (notification) => {
            if (this.listeners.onProgress)
                this.listeners.onProgress(notification);
        })
            .on('compile-start', (notification) => {
            if (this.listeners.onCompile)
                this.listeners.onCompile(notification);
        })
            .on('capture-end', (notification) => {
            if (this.listeners.onCapturEnd)
                this.listeners.onCapturEnd(notification);
        })
            .on('error', (notification) => {
            logError('There was an error in the brush encoder', notification);
            if (this.listeners.onError)
                this.listeners.onError(notification);
        })
            .on('complete', (notification) => {
            if (this.listeners.onComplete)
                this.listeners.onComplete(notification);
        });
    }
}
